import {useMemo} from "react";
import {Colors} from "@brg/ui";
import {AppTester} from "../../supporting";

export const useGetSelectedTagColor = (isFolder: boolean) => {

    const isGeo = AppTester.isGeograffee();
    const isHseDesign = AppTester.isHSEDesign();
    const isMedia = AppTester.isMediiia();
    const isDvaDesign = AppTester.isDvaDesign();
    const isGeoDafes = AppTester.isGeoDafes();
    const isGreenAward = AppTester.isGreenAward();
    const isJhonataNet = AppTester.isJhonataNet();
    
    const blueBG = useMemo(() => isMedia || isHseDesign, [isHseDesign, isMedia])
    const greenBG = useMemo(() => isGeo && !isGeoDafes, [isGeo, isGeoDafes])
    const redBG = useMemo(() => !blueBG && !greenBG && !isGeoDafes, [blueBG, greenBG, isGeoDafes])

    return useMemo(() => {
        const textColors = {
            default: Colors.geoWhite100,
            hover: Colors.geoWhite100,
            disabled: Colors.geoWhite100,
        };

        if (isJhonataNet) {
            return {
                text: textColors,
                fill: {
                    default: '#F1DB63',
                    hover: '#F1DB63',
                    disabled: '#545453'
                }
            }
        }

        if (isFolder) {
            return {
                text: textColors,
                fill: {
                    default: '#29894E',
                    hover: '#29894E',
                    disabled: '#F00',
                },
            };
        }

        if (isGreenAward) {
            return {
                text: textColors,
                fill: {
                    default: '#89B644',
                    hover: '#89B644',
                    disabled: '#89B644',
                },
            };
        }

        if (isDvaDesign) {
            return {
                text: textColors,
                fill: {
                    default: '#0C32EF',
                    hover: '#092ACD',
                    disabled: '#0C32EF',
                },
            };
        }

        if (blueBG) {
            return {
                text: textColors,
                fill: {
                    default: '#146DEE',
                    hover: '#0A56C4',
                    disabled: '#146DEE',
                },
            };
        }

        if (greenBG) {
            return {
                text: textColors,
                fill: {
                    default: '#A4B54D',
                    hover: '#AAB862',
                    disabled: '#A4B54D',
                },
            };
        }

        if (redBG) {
            return {
                text: textColors,
                fill: {
                    default: '#F00',
                    hover: '#F00',
                    disabled: '#F00',
                },
            };
        }

        if (isGeoDafes) {
            return {
                text: textColors,
                fill: {
                    default: '#E75728',
                    hover: '#D24010',
                    disabled: '#E75728',
                },
            };
        }

        return {
            text: textColors,
            fill: {
                default: '#F00',
                hover: '#F00',
                disabled: '#F00',
            },
        };
    }, [isFolder, isGreenAward, isDvaDesign, blueBG, greenBG, redBG, isGeoDafes])
}import {useMemo} from "react";
import {Colors} from "@brg/ui";
import {AppTester} from "../../supporting";

export const useGetSelectedTagColor = (isFolder: boolean) => {

    const isGeo = AppTester.isGeograffee();
    const isHseDesign = AppTester.isHSEDesign();
    const isMedia = AppTester.isMediiia();
    const isDvaDesign = AppTester.isDvaDesign();
    const isGeoDafes = AppTester.isGeoDafes();
    const isGreenAward = AppTester.isGreenAward();
    const isJhonataNet = AppTester.isJhonataNet();
    
    const blueBG = useMemo(() => isMedia || isHseDesign, [isHseDesign, isMedia])
    const greenBG = useMemo(() => isGeo && !isGeoDafes, [isGeo, isGeoDafes])
    const redBG = useMemo(() => !blueBG && !greenBG && !isGeoDafes, [blueBG, greenBG, isGeoDafes])

    return useMemo(() => {
        const textColors = {
            default: Colors.geoWhite100,
            hover: Colors.geoWhite100,
            disabled: Colors.geoWhite100,
        };

        if (isJhonataNet) {
            return {
                text: textColors,
                fill: {
                    default: '#F1DB63',
                    hover: '#F1DB63',
                    disabled: '#545453'
                }
            }
        }

        if (isFolder) {
            return {
                text: textColors,
                fill: {
                    default: '#29894E',
                    hover: '#29894E',
                    disabled: '#F00',
                },
            };
        }

        if (isGreenAward) {
            return {
                text: textColors,
                fill: {
                    default: '#89B644',
                    hover: '#89B644',
                    disabled: '#89B644',
                },
            };
        }

        if (isDvaDesign) {
            return {
                text: textColors,
                fill: {
                    default: '#0C32EF',
                    hover: '#092ACD',
                    disabled: '#0C32EF',
                },
            };
        }

        if (blueBG) {
            return {
                text: textColors,
                fill: {
                    default: '#146DEE',
                    hover: '#0A56C4',
                    disabled: '#146DEE',
                },
            };
        }

        if (greenBG) {
            return {
                text: textColors,
                fill: {
                    default: '#A4B54D',
                    hover: '#AAB862',
                    disabled: '#A4B54D',
                },
            };
        }

        if (redBG) {
            return {
                text: textColors,
                fill: {
                    default: '#F00',
                    hover: '#F00',
                    disabled: '#F00',
                },
            };
        }

        if (isGeoDafes) {
            return {
                text: textColors,
                fill: {
                    default: '#E75728',
                    hover: '#D24010',
                    disabled: '#E75728',
                },
            };
        }

        return {
            text: textColors,
            fill: {
                default: '#F00',
                hover: '#F00',
                disabled: '#F00',
            },
        };
    }, [isFolder, isGreenAward, isDvaDesign, blueBG, greenBG, redBG, isGeoDafes])
}